export default {
  portraitVideoIds: [
    'a35c99f3f1ad41fbb99d8df7662bb93e',
    '72c9e9d2bee743249e0ba4965bf586b2',
  ],
};
